export default "__VITE_ASSET__B$Dg5Qbr__"